import { createI18nText } from '../../functions';
var banksText = createI18nText({
    he: {
        israel: 'בנק ישראל (99)',
        leumi: 'בנק לאומי (10)',
        poalim: 'בנק הפועלים (12)',
        mizrachi: 'בנק מזרחי (20)',
        discount: 'בנק דיסקונט (11)',
        mDiscount: 'בנק מרכנתיל דיסקונט (17)',
        benleumi2: 'בנק הבינלאומי (31)',
        massad: 'בנק מסד (46)',
        igud: 'בנק איגוד (13)',
        yahav: 'בנק יהב (4)',
        doar: 'בנק הדואר (9)',
        jlm: 'בנק ירושלים (54)',
        digital: 'הבנק הדיגיטלי הראשון (18)',
        citi: 'סיטי בנק (22)',
        hsbc: 'HSBC (23)',
        india: 'סטייט בנק אוף אינדייה (39)',
        pagi: 'בנק פאגי (52)',
        otsar: 'בנק אוצר החייל (14)',
        ubank: 'יובנק (26)'
    },
    en: {
        israel: 'Bank of Israel (99)',
        leumi: 'Bank Leumi (10)',
        poalim: 'Bank Hapoalim (12)',
        mizrachi: 'Bank Mizrachi (20)',
        discount: 'Bank Discount (11)',
        mDiscount: 'Bank Mercantile Discount (17)',
        benleumi2: 'Bank Benleumi (31)',
        massad: 'Bank Massad (46)',
        igud: 'Union Bank (13)',
        yahav: 'Bank Yahav (4)',
        doar: 'Bank Hadoar (9)',
        jlm: 'Bank of Jerusalem (54)',
        digital: 'First Digital Bank (18)',
        citi: 'Citibank (22)',
        hsbc: 'HSBC (23)',
        india: 'State bank of India (39)',
        pagi: 'Bank Pagi (52)',
        otsar: 'Bank Otsar Ha-Hayal (14)',
        ubank: 'U-Bank (26)'
    }
});
export default banksText;
//# sourceMappingURL=banksText.js.map